import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/pages/about/AboutContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/GeneralContent/index.tsx");
